import { postData, putData, deleteData } from '../axiosServices'
const token = localStorage.getItem('token');

export const getQuestionsByLevel = (module_id, topic_id, data) => {
    const url = `practices/${module_id}/topic/${topic_id}/level`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return postData(url, data, { headers });
}
export const addPracticeQuestion = (module_id, topic_id, data) => {
    const url = `practices/${module_id}/topic/${topic_id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return postData(url, data, { headers });
}
export const updatePracticeQuestion = (practice_id, module_id, topic_id, data) => {
    const url = `practices/${practice_id}/module/${module_id}/topic/${topic_id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return putData(url, data, { headers });
}
export const deletePracticeQuestion = (practice_id, module_id, topic_id) => {
    const url = `practices/${practice_id}/module/${module_id}/topic/${topic_id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return deleteData(url, { headers });
}